<script setup lang="ts">
import { computed } from 'vue';
import { AdpDocumentBasicInfo } from '@/types';
import { getPageUrl } from '@/utils/adpDocument';
import { unsetRedirectUrl } from '@/utils/rightClickOpenTab';

interface Props {
  adpDocument: AdpDocumentBasicInfo;
  usePdfUrl?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
  usePdfUrl: true,
});

const emit = defineEmits<{
  'article-clicked': [adpDocument: AdpDocumentBasicInfo];
  'article-link-clicked': [];
  'article-link-context-menu': [event: Event];
}>();

const href = computed(() => getPageUrl(props.adpDocument, props.usePdfUrl));

const tapArticle = async () => {
  if (!props.adpDocument) return;

  emit('article-clicked', props.adpDocument);
  emit('article-link-clicked');
};

const setRightClickRedirectUrl = (event: Event) => {
  if (!props.adpDocument) return;
  emit('article-link-context-menu', event);
};
</script>

<template>
  <a
    :href="href"
    target="_blank"
    rel="noopener noreferrer"
    @click.stop="tapArticle()"
    @click.middle="tapArticle()"
    @contextmenu="setRightClickRedirectUrl"
    @mouseleave="unsetRedirectUrl"
  >
    <slot></slot>
  </a>
</template>

<style scoped lang="scss"></style>
